import styled from 'styled-components';
import {
  whiteColor,
  screenSize,
  mediumFont,
  regularFont,
  appBackgroundColor,
} from '@app/styles';
import googleIconUrl from '@app/assets/images/google.svg';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  margin-top: 65px;
  button {
    position: relative;
  }
  @media (${screenSize.tablet}) {
    display: flex;
    align-items: center;
    background-position: 0 -2px;
    margin-top: 55px;
  }
`;

export const InnerContainer = styled.div`
    width: calc(100vw - 30px);
    position: relative;
    margin: 0 auto;
    overflow-x: hidden;
    @media (${screenSize.tablet}){
      width: 440px;
        padding: 85px 30px 35px;
        margin: 0 auto;
        box-shadow: 0px 5px 10px rgb(13 18 51 / 10%);
        background-color: ${whiteColor};       
        border-radius:6px;
        z-index: 1;  
    }
  }
`;

export const Heading = styled.div`
  font-size: 21px;
  font-family: Noto Serif;
  color: rgb(58, 67, 94);
  font-weight: 600;
  text-align: center;
  margin: 30px auto;
  @media (${screenSize.tablet}) {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 64px;
    margin: 0 auto;
    border-bottom: 1px solid #edeff3;
  }
`;

export const Seperator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2px;
  margin: 40px 0 30px;
  background-color: #bcc6cc;
  span {
    padding: 0 10px;
    background-color: ${appBackgroundColor};
    color: #858f96;
    ${mediumFont}
  }
  @media (${screenSize.tablet}) {
    height: 1px;
    span {
      background-color: ${whiteColor};
    }
  }
`;

export const RememberSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  div {
    margin-bottom: 0;
    width: auto;
  }
  span {
    font-size: 14px;
    color: #3a435e;
    ${regularFont};
  }
  a {
    font-size: 14px;
    color: #3a435e;
    ${regularFont}
  }
`;
export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-image: url(${googleIconUrl});
  background-repeat: no-repeat;
  background-position: 0 center;
`;

export const Text = styled.p`
  font-size: 15px;
  color: rgb(98 105 125);
  letter-spacing: -0.38px;
  text-align: center;
  line-height: 24px;
  ${mediumFont};
  a {
    font-size: 14px;
    color: #da375f;
    opacity: 1;
  }
`;
export const ErrorMessage = styled.p`
  font-size: 14px;
  color: #ec4160;
  margin: 0;
  position: absolute;
  bottom: -22px;
  @media (${screenSize.tablet}) {
    bottom: 8px;
  }
`;
export const SavingIndicator = styled.div`
  position: absolute;
  right: 30px;
  top: 16px;
`;
export const IntroText = styled.p`
  position: absolute;
  top: 14%;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 16px;
  color: rgb(58, 67, 94);
  ${regularFont}
  @media (${screenSize.tablet}) {
    position: relative;
    top: auto;
    padding: 0;
    margin-bottom: 40px;
  }
`;

export const RowItem = styled.div`
  width: 100%;
  position: relative;
  min-height: 115px;
  @media (${screenSize.tablet}) {
    margin: 0;
  }
`;
